/** HTML template that loads the IIFE bundle and mounts ChatUI */

import type { DetectedProvider } from './types.js';

export function getHtml(providers: DetectedProvider[], mode: string): string {
  const firstProvider = providers[0]?.name ?? 'xai';
  const availableNames = JSON.stringify(providers.map(p => p.name));

  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Geepers Chat</title>
  <style>
    html, body { margin: 0; padding: 0; height: 100%; background: #09090b; }
    #app { height: 100%; }
  </style>
</head>
<body>
  <div id="app"></div>
  <script src="/dist/index.iife.global.js"></script>
  <script>
    (function() {
      var chat = new GChat.ChatUI('#app', {
        gateway: '',
        apiKey: 'local',
        provider: '${firstProvider}',
        theme: 'dark',
      });

      // Filter dropdown to only show available providers
      var available = new Set(${availableNames});
      var select = document.querySelector('.gchat-provider-select');
      if (select) {
        Array.from(select.options).forEach(function(opt) {
          if (!available.has(opt.value)) opt.remove();
        });
      }
    })();
  </script>
</body>
</html>`;
}
